import * as _ from 'lodash';
import * as utility from '../misc/utility';
import { BaseObject } from './BaseObject';

function parsePrice(val) {
    if (/^-?\d+\.\d\d\d\d$/.test(val))
        return parseFloat(val);
    throw new Error('Error parsing price');
}

export class VariablePrice {
    constructor(src) {
        if (src && typeof src === 'string') {
            this.items = src.split(";").map(val => {
                var split = val.indexOf(":");
                if (split < 0) throw new Error("Error parsing variable price");
                var max = parseInt(val.substring(0, split));
                var amount = parsePrice(val.substring(split + 1));
                return ({ max, amount });
            });
        } else {
            this.items = [];
        }
    }

    toJSON() {
        return this.items.map(x => x.max.toFixed(0) + ":" + x.amount.toFixed(4)).join(";");
    }

    clone() {
        return new VariablePrice(this.toJSON());
    }

    findAmount(minutes) {
        const ordered = _.orderBy(this.items, ['max'], ['asc']);
        const variable = ordered.find(x => x.max >= minutes);
        return variable ? variable.amount : null;
    }
}

export class WageType extends BaseObject {
    constructor(obj) {
        super();

        if (_.isObjectLike(obj)) {
            _.assign(this, obj);

            this.display = this.Code + ' ' + this.Name;

            if (this.MaxPayments === 0) {
                this.MaxPayments = null;
            }

            var periods = this.Periods || [];
            periods.forEach(x => {
                x.From = utility.parseDate(x.From);
                x.VariablePrice = new VariablePrice(x.VariablePrice);
            });
            this.Periods = _.orderBy(periods, ['From'], ['desc']);
        }
    }

    /**
     * Gets the period corresponding to supplied date.
     * May be null.
     * @param {Date} date
     */
    getPeriod(date) {
        const ordered = _.orderBy(this.Periods, ['From'], ['desc']);
        return ordered.find(x => x.From <= date);
    }
}

export const wageModelGroups = Object.freeze({
    meeting: 0,
    lostIncome: 1,
    travel: 2,
    other: 3,
});

// Index in the array should be same as id
export const wageModelGroupInfo = Object.freeze([
    Object.freeze({ id: 0, name: 'Mötesarvode' }),
    Object.freeze({ id: 1, name: 'Förlorad inkomst' }),
    Object.freeze({ id: 2, name: 'Km-ersättning' }),
    Object.freeze({ id: 3, name: 'Övrigt' }),
]);

export const wageModels = Object.freeze({
    meetingFixed: 0,
    meetingVariable: 1,
    meetingAppear: 2,
    lostIncomeFixed: 3,
    lostIncomeIndividual: 4,
    lostIncomeSystem: 5,
    travel: 6,
    other: 7,
});

// Index in the array should be same as id
export const wageModelInfos = Object.freeze([
    Object.freeze({ id: 0, group: 0, hasTimes: true , hasUnitPrice: true , name: 'Möte - Fast timarvode' }),
    Object.freeze({ id: 1, group: 0, hasTimes: true , hasUnitPrice: false, name: 'Möte - Variabelt timarvode' }),
    Object.freeze({ id: 2, group: 0, hasTimes: false, hasUnitPrice: true , name: 'Möte - Grundarvode' }),
    Object.freeze({ id: 3, group: 1, hasTimes: false, hasUnitPrice: true , name: 'Förlorad inkomst - à-pris/belopp' }),
    Object.freeze({ id: 4, group: 1, hasTimes: false, hasUnitPrice: false, name: 'Förlorad inkomst - Individuell' }),
    Object.freeze({ id: 5, group: 1, hasTimes: false, hasUnitPrice: false, name: 'Förlorad inkomst - Individuell i lönesystem' }),
    Object.freeze({ id: 6, group: 2, hasTimes: false, hasUnitPrice: true , name: 'Km-ersättning' }),
    Object.freeze({ id: 7, group: 3, hasTimes: false, hasUnitPrice: true , name: 'Övrigt' }),
]);
